import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const ParkPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "park-page" */'./park.page.js'),
	modules: ['./park.page.js'],
	webpack: () => [require.resolveWeak('./park.page.js')],
	loading: CustomLoadableLoading,
});

export default ParkPageAsync;
